import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const DropdownLink = styled(Link)`
  background: ${({ selected }) => selected ? '#e0e0e0' : 'var(--current-link)'};
  color: var(--current-text);
  display: flex;
  align-items: center;
  padding-left: 4rem;
  height: 33px;
  font-size: 13px;
  text-decoration: none;
  border-left: ${({ selected }) => selected ? '4px solid #4D9CC0' : 'none'};

  &:hover {
    background: var(--hover-sidebar-color);
    cursor: pointer;
    border-left: 4px solid #4D9CC0;
  }
`;

const SidebarLink = styled(Link)`
  background: ${({ selected }) => selected ? '#e0e0e0' : 'none'};
  color: -var(--current-text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  text-decoration: none;
  border-left: ${({ selected }) => selected ? '4px solid #4D9CC0' : 'none'};

  &:hover {
    background: var(--hover-sidebar-color);
    cursor: pointer;
    border-left: 4px solid var(--primary-color);
  }
`;

const IconContext = styled.div`
  display: flex;
  align-items: center;
  color: var(--current-text);
`;

const SidebarSubMenu = ({ item, selectedPath }) => {
  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      <SidebarLink to={item.path} onClick={item.subNav && showSubnav} selected={selectedPath === item.path}>
        <IconContext>
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </IconContext>
        <IconContext>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </IconContext>
      </SidebarLink>
      {subnav && item.subNav.map((val, key) => {
        return (
          <DropdownLink to={val.path} key={key} selected={selectedPath === val.path}>
            {val.icon}
            <SidebarLabel>{val.title}</SidebarLabel>
          </DropdownLink>
        );
      })}
    </>
  );
}

export default SidebarSubMenu;
